import React from "react";
import { Form, Accordion, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";

/**
 * Email CC/BCC options accordion component
 */
const EmailCCBCCOptions = ({
  ccMenuOpen,
  onToggleCCMenu,
  ccAccountManagers,
  ccExternalAccountManagers,
  cc,
  bcc,
  onChange,
}) => {
  return (
    <Accordion active={ccMenuOpen} as={Form.Field}>
      <Accordion.Title active={ccMenuOpen} index={0} onClick={onToggleCCMenu}>
        <Icon name="dropdown" />
        CC/BCC Options
      </Accordion.Title>
      <Accordion.Content active={ccMenuOpen}>
        <Form.Group>
          <Form.Checkbox
            toggle
            name="ccAccountManagers"
            checked={ccAccountManagers}
            onChange={onChange}
            label="CC Account Managers"
          />
          <Form.Checkbox
            toggle
            name="ccExternalAccountManagers"
            checked={ccExternalAccountManagers}
            onChange={onChange}
            label="CC External Account Managers"
          />
        </Form.Group>
        <Form.Input
          label="CC"
          placeholder="email1@test.com,email2@test.com"
          onChange={onChange}
          name="cc"
          value={cc}
        />
        <Form.Input
          label="BCC"
          placeholder="email1@test.com,email2@test.com"
          onChange={onChange}
          name="bcc"
          value={bcc}
        />
      </Accordion.Content>
    </Accordion>
  );
};

EmailCCBCCOptions.propTypes = {
  ccMenuOpen: PropTypes.bool.isRequired,
  onToggleCCMenu: PropTypes.func.isRequired,
  ccAccountManagers: PropTypes.bool.isRequired,
  ccExternalAccountManagers: PropTypes.bool.isRequired,
  cc: PropTypes.string.isRequired,
  bcc: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EmailCCBCCOptions;
